import { render, staticRenderFns } from "./faq-tabs.vue?vue&type=template&id=0323269e&scoped=true&"
import script from "./faq-tabs.vue?vue&type=script&lang=js&"
export * from "./faq-tabs.vue?vue&type=script&lang=js&"
import style0 from "./faq-tabs.vue?vue&type=style&index=0&id=0323269e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0323269e",
  null
  
)

export default component.exports